function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(-25.625 -0.625)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M2167.12,915.4a4.437,4.437,0,0,0,1.041-2.82c0-2.791-2.74-5.053-6.121-5.053s-6.121,2.262-6.121,5.053,2.74,5.053,6.121,5.053a6.942,6.942,0,0,0,3.786-1.088l-.018.016,2.353,1.534-1.04-2.7Z",
  transform: "translate(-2129.919 -906.53)",
  fill: "none",
  stroke: "#b9bbcb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}));

var SvgChatSmall = function SvgChatSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.992,
    height: 11.319,
    viewBox: "0 0 12.992 11.319",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatSmall.4ed05879.svg";
export { ForwardRef as ReactComponent };